let marker;

window.initMap = () => {
    const position = {
        lat: -34.553801,
        lng: -58.527114,
    };

    const map = new google.maps.Map($('.map')[0], {
        zoom: 17,
        center: position,
    });

    marker = new google.maps.Marker({
        position,
        map,
        visible: false,
    });
};

$('.view-map').on('click', event => {
    event.preventDefault();
    $('.map').removeClass('grayscale');
    $('.contact').find('.overlay, .content').fadeOut(() => {
        $('.hide-map').show();
    });
    marker.setVisible(true);
});

$('.hide-map').on('click', event => {
    event.preventDefault();
    $('.map').addClass('grayscale');
    $('.contact').find('.overlay, .content').fadeIn();
    $('.hide-map').hide();
    marker.setVisible(false);
});



/** WEBPACK FOOTER **
 ** ./scripts/contact.js
 **/